<template>
    <!-- ==============================================
**How it works**
=================================================== -->
        <section class="how-it-work-items padding-lg">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="content-area">
                            <div class="icon"><span>01</span></div>
                            <div class="text-area">
                                <h3 class="pb-2">Class</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since been</p>
                           <ul class="more-features-list">
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                        </ul> </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <figure class="right">
                            <img :src="`${baseURL}assets/images/class.jpg`" class="img-fluid" alt=""></figure>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 order-2 order-md-12">
                        <figure>
                            <img :src="`${baseURL}assets/images/sg.jpg`" class="img-fluid" alt=""></figure>
                    </div>
                    <div class="col-md-6 order-1 order-md-12">
                        <div class="content-area">
                            <div class="icon"><span>02</span></div>
                            <div class="text-area">
                                <h3 class="pb-2">Support group</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since been</p>
                           <ul class="more-features-list">
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                        </ul> </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="content-area">
                            <div class="icon"><span>03</span></div>
                            <div class="text-area">
                                <h3 class="pb-2">Webinar</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since been</p>
                         <ul class="more-features-list">
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                        </ul>   </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <figure class="right">
                            <img :src="`${baseURL}assets/images/webinar.jpg`" class="img-fluid" alt=""></figure>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 order-2 order-md-12">
                        <figure>
                            <img :src="`${baseURL}assets/images/rental.jpg`" class="img-fluid" alt=""></figure>
                    </div>
                    <div class="col-md-6 order-1 order-md-12">
                        <div class="content-area">
                            <div class="icon"><span>04</span></div>
                            <div class="text-area">
                                <h3 class="pb-2">Rental</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since been</p>
                            <ul class="more-features-list">
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                        </ul></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="content-area">
                            <div class="icon"><span>05</span></div>
                            <div class="text-area">
                                <h3 class="pb-2">Product</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since been</p>
                          <ul class="more-features-list">
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                        </ul> </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <figure class="right">
                            <img :src="`${baseURL}assets/images/product.jpg`" class="img-fluid" alt=""></figure>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 order-2 order-md-12">
                        <figure>
                            <img :src="`${baseURL}assets/images/membership.jpg`" class="img-fluid" alt=""></figure>
                    </div>
                    <div class="col-md-6 order-1 order-md-12">
                        <div class="content-area">
                            <div class="icon"><span>06</span></div>
                            <div class="text-area">
                                <h3 class="pb-2">Membership</h3>
                                <p>Lorem Ipsum is simply dummy text of the printing 
                                    and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since beenLorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                    Lorem Ipsum has been the industry's standard dummy text ever since been
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                    Lorem Ipsum has been the industry's standard dummy text ever since been</p>
                                    <ul class="more-features-list">
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                            <li>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the.</p>
                            </li>
                        </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'ServicesPage',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
    }
  },
}
</script>
